import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { FolderInterface } from 'app/models/folder.model';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';

@Injectable({
  providedIn: 'root',
})
export class FolderDataTransformPost extends DataTransformAbstractPost {
  constructor(protected datePipe: DatePipe) {
    super();
  }

  transform(folder: FolderInterface): FolderInterface {
    console.log('FolderDataTransformPost transform', folder);
    folder.customers = (folder.customers || []).map((v) => v.id) as any;
    return folder;
  }
}
